import React from "react";

import {
	useTheme,
} from "@mui/material";
import { BarChart, axisClasses } from "@mui/x-charts";
import {
	BarElement,
	CategoryScale,
	Chart as ChartJS,
	Legend,
	LinearScale,
	Title,
	Tooltip,
} from "chart.js";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

import { useTime } from "@/components/Application/TimeContext";
import { tokens } from "@/components/Application/theme";

import DashboardCard from "@/helpers/components/Dashboard/DashboardCard";

import { useFetchArchivedProcedures } from "@/service/ArchiveQueries";

ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
);

dayjs.extend(utc);

const ArchiveProjectsChart: React.FC<any> = ({
	startDate,
	endDate,
	selectedUser,
}) => {
	const { data: archivedProcedures, isLoading } = useFetchArchivedProcedures({
		StartDate: startDate ? dayjs(startDate).toDate() : undefined,
		EndDate: endDate
			? dayjs(endDate).startOf("day").add(1, "day").toDate()
			: undefined,
		SelectedUser: selectedUser ?? 0,
	});

	const theme = useTheme();
	const colors = tokens(theme.palette.mode);

	// Group  by month
	const groupedData: { [key: string]: number } = {};
	const monthsInCurrentYear =
		dayjs(startDate).year() === dayjs().year() ? dayjs().month() + 1 : 12;
	const monthNumbers = Array.from(
		{ length: monthsInCurrentYear },
		(_, i) => i + 1,
	);
	monthNumbers.forEach((month, index) => {
		const monthName = dayjs().month(index).format("MMM-YY");
		groupedData[monthName] = 0;
	});
	archivedProcedures?.ArchivedProjects.forEach((procedure) => {
		const date = procedure.Created;

		const month = dayjs.utc(date).tz(useTime().timezone).format("MMM-YY");
		const year = dayjs(date).year();
		if (year !== dayjs(startDate).year()) return;
		groupedData[month] === undefined
			? (groupedData[month] = 1)
			: groupedData[month]++;
	});

	const labels = Object.keys(groupedData);
	const dataValues: {
		month: string;
		completed: number;
	}[] = Object.entries(groupedData).map(([key, value]) => {
		return { month: key, completed: value };
	});

	// prep chart data
	const data = {
		labels: labels,
		datasets: [
			{
				label: "Number of Archived Projects",
				data: dataValues,
				backgroundColor: "rgba(75, 192, 192, 0.6)",
			},
		],
	};

	const options = {
		yAxis: [
			{
				label: "Number of procedures",
			},
		],
		series: [
			{
				dataKey: "completed",
				label: `Completed procedures`,
				color: colors.greenAccent[500],
			},
		],
		height: 400,
		title: "Hey",
		sx: {
			[`& .${axisClasses.directionY} .${axisClasses.label}`]: {
				transform: "translateX(-10px)",
			},
			[`& .${axisClasses.directionX} .${axisClasses.tickLabel}`]: {
				transform: "translateY(10px) translateX(-14px) rotate(-45deg)",
			},
			position: "relative",
		},
	};

	return (

			<DashboardCard>
				<BarChart
					loading={isLoading}
					dataset={dataValues}
					{...options}
					xAxis={[
						{
							scaleType: "band",
							dataKey: "month",
							tickPlacement: "middle",
						},
					]}
					height={300}
				/>
			</DashboardCard>

	);
};

export default ArchiveProjectsChart;
